import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import * as generalTracking from './snowplow';
import * as lptracking from './landing-page-tracking';
import * as crmTracking from './crm-tracking';
export var snowplow = _objectSpread(_objectSpread(_objectSpread({}, generalTracking), lptracking), crmTracking);
export { GTM_EVENT_LABELS } from './gtm';